import React from "react";
import { LANDING_PAGE_METRICS } from "../../constants/text_constants";
import SectionHeading from "./SectionHeading";
import ScrollCarousel from "scroll-carousel-react";
import { useMediaQuery } from "react-responsive";


const MetricsSection = () => {
  const isMobile = useMediaQuery({ maxWidth: 767 }); // Tailwind md breakpoint is 768px
  return (
    <div className="flex flex-col items-center md:my-[3rem]">
      <SectionHeading
        heading={LANDING_PAGE_METRICS?.heading}
        headingColor={"#130C40"}
        subHeading={LANDING_PAGE_METRICS?.subHeading}
      />
      <div
        className="lg:flex md:border-t-0 md:border-b-0 border-t-[2px] border-b-[2px] border-gray-200 md:max-h-auto max-h-[152px] overflow-y-scroll  md:overflow-y-hidden w-full md:bt-0 md:bb-0 bt-1 bb-1  lg:flex-wrap lg:justify-center grid md:grid-cols-2 grid-cols-1 lg:gap-[5rem] gap-[1rem]"
        style={{
          fontFamily: "DM Sans",
          fontStyle: "normal",
          lineHeight: "normal",
        }}
      >
        { isMobile ?
        <ScrollCarousel autoplay autoplaySpeed={8} speed={7}>
        {LANDING_PAGE_METRICS?.metrics.map((ele, i) => (
          <div
            id={ele?.id}
            key = {i}
            className="bg-[#F8FCFD] p-7 rounded-lg flex flex-col items-center hover:bg-gradient-to-r from-cyan-100 to-purple-100"
          >
            <div className="text-[#5A277C] font-bold lg:text-5xl text-2xl">
              {ele?.stats}
            </div>
            <div className="w-20 h-0.5 bg-gray-100 my-2"></div>
            <div className="flex gap-5 justify-center items-center">
              <div>
                <img alt={ele?.desc} src={ele?.img} className="w-8 h-8" loading = "lazy"/>
              </div>
              <div className = "lg:text-[1rem] text-xs">{ele?.desc}</div>
            </div>
          </div>
        ))}</ScrollCarousel>:<>{LANDING_PAGE_METRICS?.metrics.map((ele, i) => (
          <div
            id={ele?.id}
            key = {i}
            className="bg-[#F8FCFD] p-7 rounded-lg flex flex-col items-center hover:bg-gradient-to-r from-cyan-100 to-purple-100"
          >
            <div className="text-[#5A277C] font-bold lg:text-5xl text-2xl">
              {ele?.stats}
            </div>
            <div className="w-20 h-0.5 bg-gray-100 my-2"></div>
            <div className="flex gap-5 justify-center items-center">
              <div>
                <img alt={ele?.desc} src={ele?.img} className="w-8 h-8" loading = "lazy"/>
              </div>
              <div className = "lg:text-[1rem] text-xs">{ele?.desc}</div>
            </div>
          </div>
        ))}</>}
      </div>
    </div>
  );
};

export default MetricsSection;
